import React from "react";

const SectionHeader = ({ eyebrow, title, description, centered = true, light = false }) => {
  const alignment = centered ? "text-center mx-auto" : "text-left";
  const titleColor = light ? "text-white" : "text-slate-900";
  const descColor = light ? "text-stone-300" : "text-slate-600";
  const eyebrowColor = light ? "text-amber-400" : "text-amber-700";

  return (
    <div className={`max-w-3xl ${alignment}`}>
      {eyebrow && (
        <p
          className={`${eyebrowColor} text-xs md:text-sm uppercase tracking-[0.3em] font-semibold mb-4`}
          data-testid="section-eyebrow"
        >
          {eyebrow}
        </p>
      )}
      <h2 className={`font-serif ${titleColor} text-4xl sm:text-5xl leading-tight tracking-tight`}>
        {title}
      </h2>
      {description && (
        <p className={`mt-6 ${descColor} text-base lg:text-lg leading-relaxed`}>
          {description}
        </p>
      )}
    </div>
  );
};

export default SectionHeader;
